<script>
    /*
    	ResourceSavedPopup.svelte
    */

    import { onMount } from 'svelte';
    import { fade, scale } from 'svelte/transition';

    // TCARE components

    // SMUI components

    const SVG_ICON_PATH = 'img/resource_saved.svg';

    export let isShowing;
    export let onCancel;
    export let onConfirm;

    onMount(() => {
    })

    const _onClickOutside = (e) => {
        onCancel();
    }

    const _onClickInside = (e) => {
        e.stopPropagation();
    }

    const _onCancel = (e) => {
        e.stopPropagation();
        onCancel();
    }

    const _onConfirm = (e, currentService) => {
        e.stopPropagation();
        onConfirm(currentService);
    }


</script>

<style>
    .resource-popup-bg {
        z-index: 999;     /* should be above EVERYTHING even header, footer */
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
        color: var(--tcui-primary);
        background-color: rgba(123, 98, 126, .3);
    }

    .resource-popup-surface {
        position: relative;
        width: 510px;
        margin: auto;
        margin-top: 30vh;
        background-color: white;
        border-radius: 40px;
    }
    
    .resource-popup-surface .popup-button {
        width: 160px;
    }

    .resource-popup-surface .popup-button .button-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .resource-popup-surface .popup-button svg {
        width: 24px;
        height: 28px;
        margin-left: 5px;
        fill: none;
    }

    .resource-popup-surface .popup-button:hover svg path {
        stroke: white;
        fill: white;
    }



    .flex-row {
        width: 100%;
        /* padding: 5% 10%; */
        text-align: center;
    }

    .flex-row.middle {
        width: 80%;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .flex-row.bottom {
        margin-top: 40px;
        padding-bottom: 30px;
    }

    .banner {
        width: 94%;
        height: 140px;
        margin: auto;
        margin-top: 20px;
        font-size: 26px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: var(--tcui-secondary);
        background-color: #F8F3F8;
        border-radius: 18px;
        letter-spacing: 1.1px;
    }

    .banner img {
        margin-bottom: 5px;
    }

    .text-1 {
        margin-top: 35px;
        margin-bottom: 10px;
    }
    
    .spacer {
        width: 10px;
    }
    
    

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

{#if isShowing}
    <div class="resource-popup-bg" transition:fade on:click={(e) => _onClickOutside(e)} >
        <div class="resource-popup-surface" on:click={(e) => _onClickInside(e)} in:scale="{{ from: .8, duration: 250 }}" out:fade >

            <div class="flex-row jc-center top">
                <div class="banner">
                    <img src={SVG_ICON_PATH} alt={'Resource Saved'} draggable="false" >
                    Resource Saved
                </div>
            </div>

            <div class="flex-row jc-center middle">
                <div class="text-1">This resource has been successfully saved.</div>
                You can access and manage resources and previously saved resources again in “My Resources.”
            </div>

            <div class="flex-row jc-center bottom">
                <button class="tcui-button periwinkle popup-button" on:click={_onCancel}>
                    Back to Explorer
                </button>
                <div class="spacer"></div>
                <button class="tcui-button periwinkle popup-button" on:click={_onConfirm}>
                    <div class="button-content">
                        <div>My Resources</div>
                        <!-- <img src='/img/molecular-1.svg' alt='colored shape' draggable="false"> -->
                        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_117_2943)">
                                <path d="M20.423 15.7631L24.0973 13.0062C24.9632 13.7001 26.2229 13.7508 27.1505 13.0548C28.2492 12.2304 28.4723 10.6659 27.648 9.56724C26.8236 8.46862 25.2592 8.24546 24.1605 9.06985C23.2328 9.7659 22.9294 10.9895 23.3535 12.0148L19.6792 14.7717C18.74 13.8469 17.432 13.4447 16.1747 13.6251L15.0094 9.82991C15.1995 9.77063 15.4548 9.26843 15.5237 9.06985C15.5927 8.87128 15.8563 8.17257 15.2618 7.38014C14.6672 6.58771 13.5387 6.42675 12.7463 7.02134C11.9538 7.61593 11.7929 8.74439 12.3875 9.53682C12.5844 9.79934 13.0762 10.298 14.0428 10.298L14.979 14.0428C14.7553 14.1538 14.4878 14.2561 14.281 14.4113C13.5448 14.9637 13.0452 15.7158 12.7998 16.5366L7.92233 15.8409C7.5835 15.7925 7.26963 16.028 7.22137 16.3668C7.19726 16.5363 7.24403 16.6995 7.33919 16.8263C7.43436 16.9532 7.57795 17.0437 7.74742 17.0679L12.6249 17.7636C12.6296 18.4242 12.7909 19.0879 13.118 19.6948L9.43555 22.4579C8.82129 22.0608 7.99844 22.0647 7.38016 22.5286C6.58773 23.1232 6.42677 24.2517 7.02136 25.0441C7.61595 25.8365 8.74441 25.9975 9.53684 25.4029C10.1552 24.939 10.389 24.15 10.1794 23.4493L13.8618 20.6863C15.2987 22.1014 17.5989 22.2931 19.2598 21.0468C20.9209 19.8005 21.3799 17.5383 20.423 15.7631ZM13.3788 8.79302C13.1943 8.54716 13.2443 8.19718 13.4901 8.01275C13.7359 7.82832 14.0859 7.87819 14.2703 8.12405C14.4548 8.3699 14.4048 8.71989 14.159 8.90431C13.9132 9.08874 13.5632 9.03881 13.3788 8.79302ZM24.9043 10.0611C25.4563 9.64692 26.2424 9.75904 26.6565 10.311C27.0707 10.863 26.9587 11.6491 26.4066 12.0634C25.8545 12.4776 25.0684 12.3654 24.6543 11.8134C24.2401 11.2614 24.3522 10.4754 24.9043 10.0611ZM8.01272 24.3003C7.82824 24.0544 7.87823 23.7044 8.12402 23.52C8.33914 23.3586 8.63407 23.3766 8.82799 23.5485C8.84445 23.5816 8.8637 23.6138 8.88671 23.6445C8.90972 23.6752 8.9353 23.7026 8.96248 23.7277C9.07324 23.9619 9.00811 24.2501 8.79299 24.4116C8.5472 24.596 8.19715 24.5461 8.01272 24.3003ZM14.4441 19.4745C13.4816 18.1918 13.7423 16.3651 15.025 15.4026C15.2514 15.2328 15.4949 15.1018 15.7474 15.007C15.7601 15.0025 15.7725 14.9979 15.7848 14.9927C16.9547 14.5719 18.3127 14.9382 19.0969 15.9834C20.0594 17.2661 19.7989 19.0929 18.5161 20.0554C17.2333 21.0179 15.4066 20.7573 14.4441 19.4745Z" fill="#611C73"/>
                                <path d="M29.2427 23.95C28.4184 22.8513 26.8539 22.6281 25.7552 23.4525C25.704 23.4909 25.6553 23.5315 25.608 23.573L21.6961 20.9054C21.4134 20.7125 21.0277 20.7855 20.8349 21.0682C20.6815 21.2932 20.6963 21.5831 20.8511 21.7894C20.8909 21.8424 20.9399 21.8899 20.9978 21.9294L24.9095 24.5969C24.6341 25.3604 24.7352 26.2438 25.2577 26.9402C26.0821 28.0388 27.6465 28.262 28.7452 27.4376C29.8439 26.6131 30.0671 25.0486 29.2427 23.95ZM26.249 26.1963C25.8348 25.6442 25.9469 24.8581 26.499 24.4439C27.051 24.0297 27.8371 24.1419 28.2513 24.6939C28.6655 25.2459 28.5534 26.0319 28.0013 26.4461C27.4493 26.8603 26.6632 26.7482 26.249 26.1963Z" fill="#611C73"/>
                                <path d="M6.12737 14.4118C5.30298 13.3131 3.73845 13.09 2.63982 13.9144C1.54113 14.7387 1.31797 16.3032 2.14236 17.4019C2.9667 18.5005 4.53117 18.7237 5.62986 17.8993C6.72854 17.075 6.95171 15.5104 6.12737 14.4118ZM3.13366 16.6581C2.71943 16.1061 2.83155 15.32 3.38361 14.9058C3.93566 14.4915 4.72177 14.6037 5.13594 15.1557C5.55012 15.7077 5.438 16.4938 4.88595 16.908C4.33401 17.3222 3.54789 17.2102 3.13366 16.6581Z" fill="#611C73"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_117_2943">
                                <rect width="26.4844" height="26.4844" fill="white" transform="translate(21.1841) rotate(53.1178)"/>
                                </clipPath>
                            </defs>
                        </svg>    
                    </div>
                </button>
            </div>
        </div>
    </div>
{/if}
